var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled from 'styled-components';
export var Arrow = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transition: transform 0.2s ease-out;\n\n  ", "\n\n  ", ";\n"], ["\n  transition: transform 0.2s ease-out;\n\n  ", "\n\n  ", ";\n"])), function (_a) {
  var theme = _a.theme,
    inverted = _a.inverted,
    fillColor = _a.fillColor;
  return "\n    fill: ".concat(fillColor ? fillColor : inverted ? theme.palette.white.main : theme.tokens.interface.neutral.strong, ";\n  ");
}, function (_a) {
  var isOpen = _a.isOpen,
    pointRight = _a.pointRight;
  return isOpen ? "\n        transform: ".concat(pointRight ? 'unset' : 'scaleY(-1)', "\n      ") : "\n        transform: ".concat(pointRight ? 'rotate(-90deg)' : 'scaleY(1)', "\n      ");
});
var templateObject_1;